import { Typography } from "@mui/material";

interface AddressCellProps {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
}

const AddressCell = ({
  address1,
  address2,
  city,
  state,
  zip,
}: AddressCellProps) => {
  // Check if we have any data for each line of the address
  const hasStreetAddress = address1 || address2;
  const hasCityStateZip = city || state || zip;

  // Return null if there's no address data at all
  if (!hasStreetAddress && !hasCityStateZip) return null;

  // Build street line: "123 Main St Suite 100"
  // filter(Boolean) removes null/undefined values before joining
  const streetLine = [address1, address2].filter(Boolean).join(" ");

  // Build city/state/zip line: "Austin, TX 78701"
  // - If city and state exist, add comma before state
  // - If only state exists, no comma needed
  // - filter(Boolean) removes nulls, join with spaces
  // - replace handles edge case of " , " if city is missing
  const cityStateZip = [city, state ? `${city ? ", " : ""}${state}` : null, zip]
    .filter(Boolean)
    .join(" ")
    .replace(" , ", ", ");

  return (
    <Typography component="address" sx={{ fontStyle: "normal" }}>
      {streetLine}
      {/* Only show line break if we have both street and city/state/zip */}
      {streetLine && hasCityStateZip && <br />}
      {cityStateZip}
    </Typography>
  );
};

export default AddressCell;
